import React from "react";
import { Card } from "./Card";
import { Heading } from "./Heading";

interface Props {}

const CardAiCoach: React.FC<Props> = () => {
  return (
    <>
      <Heading variant={"h6"} style={{display:"flex", justifyContent:"flex-end", transform: "translateX(-10px)"}}>
        {/* <label style={styles.label}>Como eu começo?</label> */}
        x
      </Heading>
      <Card
        md={3}
        xs={4}
        pathName=""
        title="Faça seu cadastro no link abaixo"
        description={[
          "Crie seu login",
        ]}
        // button="Como funciona"
      ></Card>
      <Card
        md={3}
        xs={4}
        pathName=""
        title="Configure seu backoffice de treinamento"
        description={[
        ]}
        // button="Como funciona"
      ></Card>
      <Card
        md={3}
        xs={4}
        pathName=""
        title="Crie uma rotina de treinamento"
        description={[
          "Quanto mais perguntas você avaliar e classificar, melhor treinado com o seu estilo o bot vai ficar",
        ]}
        // button="Como funciona"
      ></Card>
      <Card
        md={3}
        xs={4}
        pathName=""
        title="Quando se sentir pronto, configure o pagamento e disponibilize ele em uma comunidade do discord"
        description={[
          "Digite:",
          "/ask",
        ]}
        // button="Como funciona"
      ></Card>
    </>
  );
};

export default CardAiCoach;
